exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-620c7a4a] .carousel-caption{position:relative!important;right:0;bottom:1.25rem;left:0;padding-top:1.25rem;padding-bottom:1.25rem;color:#495057;text-align:center}[data-v-620c7a4a] .carousel-indicators li{background-color:rgba(85,110,230,.25)}", ""]);

// exports
